'use client';

import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from '@apex-titan/ui';
import { type ReactNode } from 'react';
import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';

type FormSelectProps<T extends FieldValues> = UseControllerProps<T> & {
  label?: string;
  'aria-label'?: string;
  required?: boolean;
  placeholder?: string;
  children: ReactNode;
  contentClassName?: string;
};

export function FormSelect<T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  disabled,
  label,
  'aria-label': ariaLabel,
  required,
  placeholder,
  children,
  contentClassName,
}: FormSelectProps<T>) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });
  return (
    <Select
      value={field.value ?? ''}
      onValueChange={field.onChange}
      disabled={disabled}
    >
      <SelectTrigger
        ref={field.ref}
        label={label}
        aria-label={ariaLabel}
        required={required}
        errorMessage={fieldState.error?.message}
        onBlur={field.onBlur}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={contentClassName}>{children}</SelectContent>
    </Select>
  );
}
